import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken} from '@/utils/auth'
import store from './store'
import {Message} from 'element-ui'


Vue.use(Router)

NProgress.configure({showSpinner: false})

export const routeArr = [
  {
    path: '/redirect',
    component: layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  { //跳转页
    path: '/jump',
    name: 'jump',
    meta: {
      title: ''
    },
    component: () => import('@/views/jump.vue')
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/home/HomeView.vue')
  },
  {
    path: '/',
    component: layout,
    hidden: true,
    meta: {
      menuType: 2
    },
    children: [
      // {
      //   path: '/chjg',
      //   name: 'chjg',
      //   meta: {
      //     title: '层户结构'
      //   },
      //   component: () => import('@/views/zzjc/ysgltz/bzdz/bzdz/components/ChjgShow.vue')
      // }
    ]
  },
  // {
  //   path: '/boot',
  //   name: 'boot',
  //   meta: {
  //     title: '引导页'
  //   },
  //   component: () => import('@/views/boot/bootView.vue')
  // },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    meta: {
      title: '登录'
    },
    component: () => import('./views/login/index.vue')
  },
  {
    path: '/',
    component: layout,
    hidden: true,
    meta: {
      menuType: 2
    },
    children: [
      {
        path: '/404',
        component: (resolve) => require(['@/views/error/404'], resolve),
        name: '404',
        meta: {title: '404'}
      }
    ]
  },
  {
    path: '/',
    component: layout,
    hidden: true,
    meta: {
      menuType: 2
    },
    children: [
      {
        path: '/403',
        component: (resolve) => require(['@/views/error/403'], resolve),
        name: '403',
        meta: {title: '403'}
      }
    ]
  },
  {
    path: '/',
    component: layout,
    hidden: true,
    meta: {
      menuType: 2
    },
    children: [
      {
        path: '/null',
        component: (resolve) => require(['@/views/error/null'], resolve),
        name: 'null',
        meta: {title: '功能开发建设中'}
      }
    ]
  },
  {
    path: '/',
    component: layout,
    hidden: true,
    meta: {
      menuType: 2
    },
    children: [
      {
        path: '/user/center',
        component: (resolve) => require(['@/views/sys/user/info/index'], resolve),
        name: 'UserInfo',
        meta: {title: '个人中心'}
      }
    ]
  },
]

let router = new Router({
  // base: '/lsshzl/',
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes: routeArr
})

// 普通用户是否需要先选择部门（超管不需要）
function needSelectDept() {
  const userId = store.state.user.userData.userId
  if (userId == -1 || userId === '-1') return false
  return !store.state.user.currentDeptId
}

// 已登录后的部门访问控制
function handleDeptAccess(to, next) {
  if (needSelectDept()) {
    // 未选部门：只允许停留在 /jump
    if (to.path !== '/jump') {
      return next({ path: '/jump', replace: true })
    }
    return next()
  }
  // 已选部门或超管：禁止再进入 /jump
  if (to.path === '/jump') {
    const userId = store.state.user.userData.userId
    if (userId == -1 || userId === '-1') {
      return next({ path: '/sys/user', replace: true })
    }
    return next({ path: '/home/index', replace: true })
  }
  return next()
}

// 路由守卫
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    // 防止重复登录
    if (to.path === '/login') {
      Message({
        message: '请勿重复登录!',
        type: 'error'
      })
      return next({name: from.name ? from.name : '/index'})
    } else {
      if (store.getters.roles.length === 0) {
        // 获取用户信息
        store.dispatch('GetInfo').then(res => {
          const roles = res.roles
          store.dispatch('GenerateRoutes', {roles}).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            handleDeptAccess(to, (location) => {
              if (location === undefined) {
                next({...to, replace: true})
              } else {
                next(location)
              }
            })
          })
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Message({
              message: '登录时间失效，请重新登录！',
              type: 'warning'
            })
            next({path: '/login'})
          })
        })
      } else {
        handleDeptAccess(to, next)
      }
    }
  } else {
    if (to.path === '/login' || to.path === '/boot') {
    // if (to.path === '/login') {
      return next()
    } else {
      localStorage.setItem('isLogout',true)
      localStorage.setItem('isLoginDialog',true)
      // 未登录
      // Message({
      //   message: '请先登录!',
      //   type: 'error'
      // })
      next({name: 'login'})
    }
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
